import type { Language } from '../i18n/messages'

/**
 * Les activités du produit, dans l'ordre du catalogue (`saas.module`). Elles sont trois et
 * figées par le code — chacune a ses écrans — contrairement aux formules, que le panneau crée.
 */
export const MODULES = ['crop', 'orchard', 'livestock'] as const

/**
 * Le nom d'une formule dans la langue de l'écran.
 *
 * IL VIENT DE LA BASE (`saas.plan.name` et `labels`), PLUS DU DICTIONNAIRE. Depuis la
 * migration 0076 le super-administrateur crée des formules : une clé `platform.plan.<code>`
 * n'existerait que pour les cinq formules d'origine, et une formule nouvelle s'afficherait
 * sous son code brut. Sans nom arabe ou anglais saisi, le nom français fait foi.
 */
export function nomFormule(
  language: Language,
  plan: { name: string; nameAr?: string | null; nameEn?: string | null },
): string {
  if (language === 'ar' && plan.nameAr) return plan.nameAr
  if (language === 'en' && plan.nameEn) return plan.nameEn
  return plan.name
}
